import { useEffect, useState } from "react";
import { useParams } from "react-router";
import "./TicketsDetail.scss";
import moment from "moment";
import DownloadIcon from '@mui/icons-material/Download';
import { Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";


const TicketBooking = () => {
    const { t } = useTranslation();
    const { id } = useParams();
    const route = useLocation();
    const [ ticketDetail, setTicketDetail ] = useState<any>(route?.state);

    return(
        <div className="tickets-detail-wrapper">
            
            <div className="tickets-wrap">
            <div id="card-wrap" >
          {ticketDetail?.length > 0 && (
            <div className="row">
              {ticketDetail?.map((val: any, i: any) => {
                return (
                  <div className="col-sm-6 col-md-4">
                    <div className="ticket-wrap">
                      <div className="ticket-top-view">
                        <div className="top-ticket">
                        <div className="title-download">
                        <h5>{val.ticket_type_name}</h5>
                        </div>
                     
                        <div className="label-data-wrap">
                          <div className="row row-overiding-style">
                            <div className="col-md-6 theme-title" >
                                {t('Expiry on')} 
                            </div>
                            <p className="col-md-6 theme-value" id="ticket-values">{moment(new Date(val.expired_on)).format("DD/MM/YYYY")}</p>

                          </div>
                        </div>

                        <div className="label-data-wrap">
                           <div className="row row-overiding-style">
                            <div className="col-md-6 theme-title">
                                {t('Ticket Code')}
                            </div >
                            <p className="col-md-6 theme-value" id="ticket-values" >{val.ticket_code}</p>
                           </div>
                        </div>

                        <div className="label-data-wrap">
                           <div className="row row-overiding-style">
                            <label className="col-md-6 theme-title" >
                                {t('Booked Date')} 
                            </label>
                            <p id="ticket-values" className="col-md-6 theme-value" >{`${val.booked_on}`}</p>
                           </div>
                        </div>
            </div>

            <div className="top-ticket">
                <div className="ticket-image-wrap">
                    <img className="ticket-image" src={val.image} />
                </div>
            </div>
                        <div className="left-hole"></div>
                        <div className="right-hole"></div>

                      </div>


                    </div>
                  </div>

                );
              })}
            </div>
          )}
        </div>
            </div>
        </div>
    )
};

export default TicketBooking;

